import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { showError } from 'utils';
import { tableStyles } from '../../../css/tableStyles';
import styles from './index.module.scss';
import ActionButton from 'components/ActionButton';
import CustomLink from 'components/TableLink';
import { fetchAllSalesChannels } from 'services/api/salesChannel';

const SalesChannelsList = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [salesChannels, setSalesChannels] = useState([]);

  const fetchSalesChannelsFn = async () => {
    setLoading(true);
    try {
      const response = await fetchAllSalesChannels();
      setSalesChannels(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSalesChannelsFn();
  }, []);

  const columns = useMemo(
    () => [
      {
        name: 'Id',
        selector: 'objectId',
        sortable: false,
        cell: (row) => (
          <CustomLink
            text={row.objectId}
            linkTo={`/sales-channels/${row.objectId}`}
          />
        ),
      },
      {
        name: 'Name',
        selector: 'name',
        sortable: true,
        format: (row) => <div className={styles['name']}>{row.name}</div>,
      },
      {
        name: 'Description',
        selector: 'description',
        sortable: true,
        format: (row) => (
          <div className={styles['name']}>{row.description}</div>
        ),
      },
      {
        name: 'User Id',
        selector: 'user.objectId',
        sortable: true,
        format: (row) => <div className={styles['name']}>{row?.user?.objectId || '-'}</div>,
      },
      {
        name: 'Email',
        selector: 'user.email',
        sortable: true,
        format: (row) => <div className={styles['name']}>{row?.user?.email || '-'}</div>,
      },
      {
        name: 'Phone',
        selector: 'user.phone',
        sortable: true,
        format: (row) => <div className={styles['name']}>{row?.user?.phone || '-'}</div>,
      },
      {
        name: 'Locale',
        sortable: true,
        selector: 'locale',
      },
      {
        name: 'Active',
        selector: 'active',
        format: row => row.active?.toString() || '-',
      },
    ],
    [],
  );

  return (
    <div>
      <div className={styles['main-container']}>
        <div className={styles['header']}>
          <div className={styles['heading']}>Sales Channels</div>
          <div className={styles['buttons-container']}>
            <ActionButton
              text={
                <>
                  Sales Channel <span>+</span>
                </>
              }
              active={true}
              isLoading={false}
              onClick={() => {
                props.history.push('/sales-channel/create');
              }}
              customClass={styles['add-new-sales-channel-button']}
            />
          </div>
        </div>
        <div style={{ padding: '20px 15px' }}>
          <DataTable
            keyField="objectId"
            columns={columns}
            noHeader={true}
            data={salesChannels}
            highlightOnHover={true}
            customStyles={tableStyles}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export { SalesChannelsList };
